import classNames from "classnames";
import React, { useCallback } from "react";

import {
  DataTable as EworkDataTable,
  IDataTableProps as EworkIDataTableProps,
  RowComponent,
} from "@/eworkitComponents";

import "./_data-table.scss";

export interface IDataTableProps<T> extends EworkIDataTableProps<T> {
  onRowClick?: (rowData: T) => void;
}

export function DataTable<T>({ onRowClick, className, ...props }: IDataTableProps<T>) {
  const classes = classNames(className, "supplier-data-table", {
    "supplier-data-table--clickable-row": !!onRowClick,
  });

  const onRowClickHandle = useCallback((rowData: T) => onRowClick?.(rowData), [onRowClick]);

  return (
    <EworkDataTable
      className={classes}
      RowComponent={p => <RowComponent onClick={onRowClickHandle} {...p} />}
      {...props}
    />
  );
}
